// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-retry[data-v-09a88ddc] {\n  background-color: #ffc107;\n  color: #000;\n}", ""]);
// Exports
module.exports = exports;
